import { IconProps } from "@/types/icons";
import clsx from "clsx";

interface DeleteTrashProps extends IconProps {
  className?: string;
}

export const DeleteTrash = ({
  width = 20,
  height = 20,
  className,
  fillColor = "#B3261E",
  decorative = false,
  ariaLabel = "Delete",
}: DeleteTrashProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width + 2} ${height + 2}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M15.5 3.5V4H21v1h-2v15.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 20.5V5H3V4h5.5v-.5A1.5 1.5 0 0 1 10 2h4a1.5 1.5 0 0 1 1.5 1.5M10 3a.5.5 0 0 0-.5.5V4h5v-.5A.5.5 0 0 0 14 3zm8 17.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V5h12zM12.5 8h-1v10h1zM9 8v10H8V8zm7 10V8h-1v10z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
